import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import Login from './pages/Auth/Login';
import VolunteerLoginComingSoon from './pages/Auth/VolunteerLoginComingSoon';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import AttractionDetail from './pages/AttractionDetail';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import About from './pages/About';
import Team from './pages/Team';
import ProjectDetail from './pages/ProjectDetail';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import JobApplication from './pages/JobApplication';
import Store from './pages/Store';
import Expeditions from './pages/Expeditions';
import SpecialEventCollection from './pages/SpecialEventCollection';
import Initiatives from './pages/Initiatives';
import Community from './pages/Community';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import DashboardLayout from './components/Layout/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Bookings from './pages/Bookings';
import Book from './pages/Book';
import BookingConfirmed from './pages/BookingConfirmed';
import BookingAddOns from './pages/BookingAddOns';
import Profile from './pages/Profile';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import GoogleAnalytics from './components/GoogleAnalytics';
import MetaPixel from './components/MetaPixel';
import SiteFavicon from './components/SiteFavicon';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <SiteFavicon />
      <GoogleAnalytics />
      <MetaPixel />
      <ScrollToTop />
      <Routes>
        {/* Public Routes - No Login Required (one flow: phone OTP → if new user, show form) */}
        <Route path="/login" element={<Login />} />
        <Route path="/login/volunteer" element={<VolunteerLoginComingSoon />} />
        <Route path="/register" element={<Navigate to="/login" replace />} />
        
        {/* Public Pages with Layout */}
        <Route
          path="/*"
          element={
            <Layout>
              <Routes>
                {/* Public Pages */}
                <Route path="/" element={<Home />} />
                <Route path="/events" element={<Events />} />
                <Route path="/events/:slug" element={<EventDetail />} />
                <Route path="/attractions/:slug" element={<AttractionDetail />} />
                <Route path="/expeditions" element={<Expeditions />} />
                <Route path="/special-events/:slug" element={<SpecialEventCollection />} />
                <Route path="/initiatives" element={<Initiatives />} />
                <Route path="/community" element={<Community />} />
                <Route path="/about" element={<About />} />
                <Route path="/projects/:id" element={<ProjectDetail />} />
                <Route path="/team" element={<Team />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/contact/regional" element={<Contact />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/careers/jobs/:id" element={<JobApplication />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/blogs/:slug" element={<BlogDetail />} />
                <Route path="/blog" element={<Navigate to="/blogs" replace />} />
                <Route path="/blog/:slug" element={<BlogDetail />} />
                <Route path="/store" element={<Store />} />
                <Route path="/store/*" element={<Store />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />

                {/* Protected: Booking flow (main layout) */}
                <Route path="/book/:batchId" element={<ProtectedRoute><Book /></ProtectedRoute>} />
                <Route path="/bookings/confirmed/:id" element={<ProtectedRoute><BookingConfirmed /></ProtectedRoute>} />
                <Route path="/bookings/:id/add-ons" element={<ProtectedRoute><BookingAddOns /></ProtectedRoute>} />
                
                {/* Protected Routes - Dashboard layout with sidebar */}
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout><Dashboard /></DashboardLayout>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/bookings"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout><Bookings /></DashboardLayout>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout><Profile /></DashboardLayout>
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;
